<template>
  <LibraryListItem>
    <ReqTitleCell :title="title" :on-hold="onHold" />
    <ReqIdCell :ats-req-id="atsReqId" />
    <RequisitionListCount
      :total="publishedJobPosts"
      :tooltip-values="{
        Draft: draftJobPosts,
        Published: publishedJobPosts,
        Unpublished: unpublishedJobPosts,
        'Total Posts': totalJobPosts,
      }"
    />
    <RequisitionListCount
      class="applicants"
      :total="activeApplicants"
      :tooltip-values="{
        'Active Applications': '',
        Application: activeReviewApplicants,
        Screening: activeScreenApplicants,
        Assessment: activeAssessmentApplicants,
        Offer: activeOfferApplicants,
        'Total Applicants': totalApplicants,
      }"
    />
    <RequisitionListCount
      :total="totalDaysOpen(openedAt)"
    />
    <ReqDepartmentCell :department-name="departmentName" />
    <ReqHiringManagerCell :hiring-managers="hiringManagers" />
  </LibraryListItem>
</template>

<script setup>
import LibraryListItem from '@/components/shared/LibraryListItem.vue';
import RequisitionListCount from '@/components/requisitions/RequisitionListCount.vue';
import ReqTitleCell from '@/components/requisitions/listItemCells/ReqTitleCell.vue';
import ReqIdCell from '@/components/requisitions/listItemCells/ReqIdCell.vue';
import ReqDepartmentCell from '@/components/requisitions/listItemCells/ReqDepartmentCell.vue';
import ReqHiringManagerCell from '@/components/requisitions/listItemCells/ReqHiringManagerCell.vue';
import { getReqDaysOpen } from '@/components/requisitions/RequisitionReportApplicantsWidget/helpers';

defineProps({
  title: {
    type: String,
    default: '',
  },
  onHold: {
    type: Boolean,
    default: false,
  },
  atsReqId: {
    type: String,
    default: '',
  },
  draftJobPosts: {
    type: Number,
    default: 0,
  },
  publishedJobPosts: {
    type: Number,
    default: 0,
  },
  unpublishedJobPosts: {
    type: Number,
    default: 0,
  },
  totalJobPosts: {
    type: Number,
    default: 0,
  },
  activeApplicants: {
    type: Number,
    default: 0,
  },
  activeReviewApplicants: {
    type: Number,
    default: 0,
  },
  activeAssessmentApplicants: {
    type: Number,
    default: 0,
  },
  activeScreenApplicants: {
    type: Number,
    default: 0,
  },
  activeOfferApplicants: {
    type: Number,
    default: 0,
  },
  totalApplicants: {
    type: Number,
    default: 0,
  },
  openedAt: {
    type: String,
    default: '',
  },
  departmentName: {
    type: String,
    default: '',
  },
  hiringManagers: {
    type: Array,
    default: () => [],
  },
});

const totalDaysOpen = (openedAt) => (
  openedAt ? getReqDaysOpen({ openedAt, status: 'open' }) : ''
);
</script>

<style lang="less" scoped>
</style>
